import { useEffect } from 'react'

import { PushProgramTask } from '@apps-common/config/push-notification'
import { useNotifications } from '@apps-common/contexts'
import { INotificationPayload } from '@apps-common/types/portal/push-registration'
import { IUnitTaskQueueModel } from '@apps-common/types/portal/unit-tasks'

const key = 'program-task-queue-notification-listener'

export const useTaskQueueNotificationListener = (items: IUnitTaskQueueModel[], callback: (data: INotificationPayload) => void) => {
  const ctx = useNotifications()

  useEffect(() => {
    if (!items?.length) {
      return
    }

    ctx?.subscribeToNotifications({
      id: `${key}`,
      destination: PushProgramTask.destination,
      onNotificationReceived: (event: INotificationPayload) => {
        // console.log('Callback received in program job queue for request:', event)
        // console.log(event.data.taskQueueId, parseInt(event.data.taskQueueId, 10), queueId)
        // if (event.data.taskQueueId && parseInt(event.data.taskQueueId, 10) === queueId) {
        console.log('Callback matched for queue id:')
        callback(event)
        // }
      }
    })

    return () => {
      ctx?.unsubscribeToNotifications(`${key}`)
    }
  }, [callback, ctx, items])

  return null
}
